export const normalizeCompanyKey = (companyName)=>companyName.trim().toLowerCase();
